import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { NavigationService } from '@layout/data/navigation';
import { Notifications } from '@layout/ui/notifications';
import { User } from '@layout/ui/user';
import {
  BuiSidebar,
  BuiSidebarBody,
  BuiSidebarButton,
  BuiSidebarFooter,
  BuiSidebarHeader,
  BuiSidebarIcon,
  BuiSidebarMenu,
  BuiSidebarMenuItem,
  BuiSidebarMenuRow,
  BuiSidebarSection,
  BuiSidebarSectionContent,
  BuiSidebarSpacer,
} from '@ui/sidebar';

@Component({
  selector: 'app-sidebar',
  imports: [
    RouterLink,
    RouterLinkActive,
    MatBadge,
    MatIcon,
    MatTooltip,
    TranslocoDirective,
    Notifications,
    User,
    BuiSidebar,
    BuiSidebarBody,
    BuiSidebarButton,
    BuiSidebarFooter,
    BuiSidebarHeader,
    BuiSidebarIcon,
    BuiSidebarMenu,
    BuiSidebarMenuItem,
    BuiSidebarMenuRow,
    BuiSidebarSection,
    BuiSidebarSectionContent,
    BuiSidebarSpacer,
  ],
  host: {
    class: 'flex',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-container *transloco="let t">
      <!-- Icon Rail -->
      <aside
        buiSidebar
        class="w-12"
      >
        <!-- Header -->
        <div
          buiSidebarHeader
          class="px-1 pt-4 pb-1"
        >
          <a routerLink="/">
            <img
              class="mx-auto size-6"
              src="logo-small.svg"
              alt="GPF"
            />
          </a>
        </div>

        <!-- Body -->
        <div buiSidebarBody>
          <div
            buiSidebarSection
            class="p-0"
          >
            <div buiSidebarSectionContent>
              <ul buiSidebarMenu>
                <notifications
                  position="end-bottom"
                  class="mb-3"
                />

                @for (item of nav.navigation(); track item.id) {
                  <li
                    buiSidebarMenuItem
                    [matTooltip]="t(item.tooltip)"
                    matTooltipPosition="after"
                    [matTooltipClass]="['-ml-0.5']"
                  >
                    <div buiSidebarMenuRow>
                      @if (item.items?.length) {
                        <button
                          buiSidebarButton
                          [class.active]="
                            nav.selectedItemId() === item.id ||
                            nav.isItemActive(item)
                          "
                          [matBadge]="item.badge"
                          [matBadgeHidden]="!item.badge"
                          matBadgeSize="small"
                          (click)="nav.togglePanel(item.id)"
                        >
                          <mat-icon
                            buiSidebarIcon
                            [svgIcon]="item.icon"
                          />
                        </button>
                      } @else {
                        <a
                          buiSidebarButton
                          [routerLink]="item.route"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="
                            item.routeActiveOptions ?? { exact: true }
                          "
                          [matBadge]="item.badge"
                          [matBadgeHidden]="!item.badge"
                          matBadgeSize="small"
                          (click)="nav.closePanel()"
                        >
                          <mat-icon
                            buiSidebarIcon
                            [svgIcon]="item.icon"
                          />
                        </a>
                      }
                    </div>
                  </li>
                }
              </ul>
            </div>
          </div>

          <div buiSidebarSpacer></div>
        </div>

        <!-- Footer -->
        <div
          buiSidebarFooter
          class="hidden items-center justify-center p-2 lg:flex"
        >
          <user compact />
        </div>
      </aside>
    </ng-container>
  `,
})
export class AppSidebar {
  protected nav = inject(NavigationService);
}
